import { render, staticRenderFns } from "./ButtonActiveModalRate.vue?vue&type=template&id=60c05ef2&scoped=true&"
import script from "./ButtonActiveModalRate.vue?vue&type=script&lang=js&"
export * from "./ButtonActiveModalRate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonActiveModalRate.vue?vue&type=style&index=0&id=60c05ef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c05ef2",
  null
  
)

export default component.exports